import GeneralLoadingSplashscreen from "@/assets/svg/generalLoadingSplashscreen.svg?react";

const LoadingPage = () => (
  <div className="flex flex-col items-center justify-center h-screen bg-teal-50 p-8">
    <div className="shrink-0">
      <GeneralLoadingSplashscreen className="flex-1" />
    </div>
    <p className="text-2xl text-center font-bold text-txtHeading mt-10">
      Loading your map...
    </p>
    <p className="text-2xl text-center font-bold text-txtHeading">
      Please wait, you'll be redirected shortly to begin your analysis.
    </p>
  </div>
);

export default LoadingPage;
